module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAIZJREFUSEvtlssJwDAMQ6VNOko7eTNKNlHxodBfjooDqQfwIw9FmEgaJnExOVjSCmAx6a8ky7n7plrSDiDgjikkt7HAjme2dk6e6l+108ArXJJcBQKSdax/nNlcNs2huKnaGabn7r+5utmeXHXmP047fVz3VoQ2jr3vru4W6WixnrAraz7wAa66MB//6Rz5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_white.png
// module id = Xpw8
// module chunks = 16